import React from 'react';
import { INSTAGRAM_LINK, SUPPORT_EMAIL, WHATSAPP_LINK } from './Shared';
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-greenDeep py-12 text-brand-cream" data-id="element-90" data-mp="3ggaqtvj9sd5g">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-91" data-mp="32ovwwtntqrjm">
        <div className="mb-8 rounded-2xl border border-white/10 bg-white/5 p-6 text-sm leading-relaxed" data-id="element-92" data-mp="36p6aoshuym91">
          <p data-id="element-93" data-mp="3ueim7z0nr6ei">
            <strong className="text-brand-goldLight" data-id="element-94" data-mp="3ug3e1gvl8b8o">P.D.:</strong> Si tenés dudas, escribinos a{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-95" data-mp="37o7wzgy05fh">
              {SUPPORT_EMAIL}
            </a>{' '}
            o por{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={WHATSAPP_LINK} data-id="element-96" data-mp="3qcx8yck7oq3s">
              WhatsApp
            </a>
            . También podés encontrarnos en Instagram como{' '}
            <a className="font-semibold text-brand-amber hover:underline" href={INSTAGRAM_LINK} data-id="element-97" data-mp="2eyt8qon165qa">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="mt-3 italic text-brand-cream/75" data-id="element-98" data-mp="3gapd7j63ckfz">
            El precio de lanzamiento sube pronto. El mejor momento para tener tu sistema profesional de Flores de Bach
            es ahora.
          </p>
        </div>

        <div className="mb-10 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-7" data-id="element-99" data-mp="3q7lm3pzwj8l2">
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-100" data-mp="81pfbipu2x9d">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href={INSTAGRAM_LINK} data-id="element-101" data-mp="hriibvbwu420">
            📲 @lumen.akasha
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-amber" href="https://www.lumenakasha.com" data-id="element-102" data-mp="qt8hxofy49av">
            🌐 www.lumenakasha.com
          </a>
        </div>

        <div className="mb-8" data-id="element-103" data-mp="tvw8ij57pjh1">
          <h3 className="mb-2 font-display text-3xl font-bold text-brand-goldLight" data-id="element-104" data-mp="two07ivoux21">🔮 LUMEN AKASHA™</h3>
          <p className="text-brand-cream/80" data-id="element-105" data-mp="yuh6ebwzrr2b">El sistema profesional para terapeutas en Flores de Bach Holística.</p>
          <p className="mt-2 text-brand-cream/70" data-id="element-106" data-mp="13rg0wvkki011">
            Porque trabajar con Flores de Bach con excelencia no debería costarte la seguridad ni la rentabilidad de tu
            consultorio.
          </p>
        </div>

        <div className="space-y-2 border-t border-white/10 pt-6 text-xs text-brand-cream/50" data-id="element-107" data-mp="1hkffmvcizq7j">
          <p data-id="element-108" data-mp="1mk1s32kj52fa">
            © Lumen Akasha™ 2025 — Todos los derechos reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p data-id="element-109" data-mp="1rgsfkaynz0aq">
            Ley 25.326 — Protección de Datos Personales — República Argentina · Ley 11.723 — Propiedad Intelectual —
            República Argentina
          </p>
        </div>
      </div>
    </footer>;
}